<script>
  import {
    Navbar,
    NavbarBrand,
    Col,
    Container,
    Row,
    Input,
    Button,
    Fade,
    Card,
  } from "sveltestrap";

  let promise = Promise.resolve([]);
  let isOpen = false;

  async function fetchUsers(url) {
    const response = await fetch("https://worker.mtnlss.co/?url=" + url);
    return response.json();
  }

  async function handleUpdate(e) {
    isOpen = true;

    const formData = new FormData(e.target);
    const formUser = {};

    for (const [k, v] of formData.entries()) {
      formUser[k] = v;
    }

    promise = fetchUsers(formUser.url);
  }
</script>

<Navbar color="light" light expand="md">
  <NavbarBrand href="/">ScrapTech</NavbarBrand>
</Navbar>
<Container xxl>
  <Row>
    <Col sm="12" md={{ size: 6, offset: 3 }}>
      <div class="mt-5">
        <form on:submit|preventDefault={handleUpdate}>
          <Input type="url" name="url" placeholder="URL" />
          <Button type="submit" class="mt-3 mb-3">Obtener</Button>
        </form>
        <Fade {isOpen}>
          <Card body>
            {#await promise}
              <p>...esperando</p>
            {:then data}
              <p>Precio: {JSON.stringify(data.precio)}</p>
              <p>Dormitorios: {JSON.stringify(data.dormitorios)}</p>
              <p>Baños: {JSON.stringify(data.banos)}</p>
              <p>M2: {JSON.stringify(data.m2)}</p>
              <p>Latitud: {JSON.stringify(data.latitude)}</p>
              <p>Longitud: {JSON.stringify(data.longitude)}</p>
            {:catch error}
              <p>Ocurrio un error!</p>
            {/await}
          </Card>
        </Fade>
      </div>
    </Col>
  </Row>
</Container>

<style>
  @import "https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css";
</style>
